export default __webpack_public_path__ + "1315ff40abdf59eabedfe1358760efac.svg";